"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Icon = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _configProvider = require("../config-provider/configProvider");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ARCHIVE_ICON_LIST = ['crown-undo-o', 'html-o', 'lock-log-o', 'notebook-time-o', 'state-o', 'vpn-o', 'word-o', 'expand-panel', 'checkbox-part-o', 'file-move'];
var Icon = exports.Icon = function Icon(_ref) {
  var className = _ref.className,
    type = _ref.type,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _React$useContext = _react.default.useContext(_configProvider.ConfigContext),
    getIconPrefixCls = _React$useContext.getIconPrefixCls;
  var iconPrefixCls = getIconPrefixCls === null || getIconPrefixCls === void 0 ? void 0 : getIconPrefixCls('');
  if (ARCHIVE_ICON_LIST.includes(type)) {
    iconPrefixCls = "".concat(iconPrefixCls, "-archive");
  }
  return /*#__PURE__*/_react.default.createElement("i", _objectSpread({
    className: (0, _classnames.default)(className, "".concat(iconPrefixCls, " ").concat(iconPrefixCls, "-").concat(type))
  }, otherProps));
};
// ... existing code ...
var _default = exports.default = Icon;